import { createFieldBase, FieldBase, FieldBaseArguments } from './FieldBase';

export function createCheckboxField({
  value,
  ...options
}: CheckboxFieldArguments): CheckboxField {
  const fieldBase = createFieldBase(options);

  let self: CheckboxField = {
    ...fieldBase,
    value,
    componentType: 'checkbox',
  };

  return self;
}

// TYPES:
export interface CheckboxFieldArguments extends FieldBaseArguments {
  value?: string | number | boolean;
}

export interface CheckboxField extends FieldBase {
  componentType: string;
  value?: string | number | boolean;
  formatOnInit?: Function;
  formatOnBlur?: Function;
  dtoTransform?: Function;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/Field/CheckboxField.ts